var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfLosangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 355,
    height: 368,
    viewBox: "0 0 355 368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #707070;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #b374b1;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    className: "cls-1",
    width: 355,
    height: 368,
    transform: "translate(0 1022)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23",
    "data-name": "Mask Group 23",
    className: "cls-2",
    transform: "translate(0 -1022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-197.937 1021.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-3",
    d: "M148.749,31.755a27.287,27.287,0,0,0-18.148,6.8L40.278,118.469A29.469,29.469,0,0,0,31,145.687L52.625,266.719a28.6,28.6,0,0,0,18.038,21.888l112.061,41.1a26.99,26.99,0,0,0,27.3-5.24l90.345-79.932a29.422,29.422,0,0,0,9.282-27.219L288.021,96.4a28.627,28.627,0,0,0-18.038-21.888l-111.973-41.1a26.953,26.953,0,0,0-9.26-1.656m0-31.755a56.554,56.554,0,0,1,19.505,3.47l111.952,41.1c19.709,7.24,34.178,24.845,37.937,46.158l21.629,120.9a61.759,61.759,0,0,1-19.505,57.068L229.943,348.6a56.75,56.75,0,0,1-57.464,11.023l-111.93-41.1c-19.676-7.212-34.14-24.758-37.937-46.022L.983,151.471A61.735,61.735,0,0,1,20.488,94.426l90.3-79.932A57.253,57.253,0,0,1,148.749,0Z",
    transform: "translate(-0.003 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfLosangle);
export default __webpack_public_path__ + "static/media/half_losangle.973a6f7a2c33f5e45cb3d7701a2e7ec9.svg";
export { ForwardRef as ReactComponent };